export class PrincipalUser {
    ID: number;
    UserName: string;
    Pwd: string;
    UserType: string;
    ViewReport: string;
    AccessRight: number;
    Approval_1: boolean
    Approval_2: boolean;
    Area: string;
    ReceiveEmail: string;
    PRNGroup: number;
    Notes: string;
    IsActive: boolean;
    Email: string;
    UserNameInternal: string;
    GroupUserCode: string;
}
